export default __webpack_public_path__ + "static/media/8.1591e436.png";